export default "__VITE_ASSET__B1wV89F7__"